import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveTwoLeggedToken(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const token = await axios.get('/autodesk/authentication/two-legged/token', config);
        return token.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
